
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, PropSync, Watch } from "vue-property-decorator";
@Component({
	name: "PcmPagination",
	components: {}
})
export default class PcmPagination extends Vue {
	@PropSync("currentPage", { type: Number }) currentPageC!: number;
	@PropSync("total", { type: Number }) totalC!: number;
	@PropSync("pages", { type: Number }) pagesC!: number;
	@PropSync("currentPageSize", { type: Number }) currentPageSizeC!: number;
	// @Prop({
	//   type: Number,
	//   default: 0,
	//   validator: (value) => {
	//     return value;
	//   },
	// }) total!:number;
	mounted() {
		document.getElementsByClassName(
			"el-pagination__jump"
		)[0].childNodes[0].nodeValue = "";
		document.getElementsByClassName(
			"el-pagination__jump"
		)[0].childNodes[2].nodeValue = "";
		const div = document.createElement("div");
		const div2 = document.createElement("div");

		div.className = "pagination-jump";
		div.innerHTML = "跳转";
		div2.className = "pagination-text font-16";
		div2.innerHTML = "/ " + this.pagesC;
		document.getElementsByClassName("el-pagination__jump")[0].append(div2);
		document.getElementsByClassName("el-pagination__jump")[0].append(div);
		document
			.getElementsByClassName("el-pagination__jump")[0]
			.getElementsByClassName("pagination-jump")[0]
			.addEventListener("click", () => {
				this.currentChange(this.currentPageC);
			});
	}
	updated() {}
	private currentChange(val: number) {
		this.$emit("currentChange", val);
	}
	@Watch("currentPageC")
	onPageChanged(newValue: number, oldValue: number) {}
	@Watch("pages")
	onTotalChanged(newValue: number, oldValue: number) {
		if (
			document
				.getElementsByClassName("el-pagination__jump")[0]
				.getElementsByClassName("pagination-text")[0]
		) {
			document
				.getElementsByClassName("el-pagination__jump")[0]
				.getElementsByClassName("pagination-text")[0].innerHTML =
				"/ " + newValue;
		}
	}
}
